import React from 'react'

function Style2Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="67" height="21" viewBox="0 0 67 25"><defs>
        
        </defs><g transform="translate(-117.5 -704)">
        <text class="a" fill="#7c7c7c" font-size="8px" fontFamily="OpenSans-Bold, Open Sans" fontWeight="700" transform="translate(118 713)">
        <tspan x="0" y="0">xxxx</tspan>
        </text><line class="b" fill="none" stroke="#acacac" x2="67" transform="translate(117.5 728.5)"/>
        </g>
        </svg>
    )
}

export default Style2Icon
